import { DialogSize } from '../../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    defaultSystemAnnouncementResource,
    SystemAnnouncementMutationResourceSchema,
    type SystemAnnouncementResource,
    useSystemAnnouncementActions,
} from '../../../../resource/resources/persistables/system/announcement/systemAnnouncementResource';
import { Form_DisplayComponentBaseView } from '../../form-components/Form_DisplayComponentBaseView';
import { SystemAnnouncementContent } from '../../resource-contents/SystemAnnouncementContent';
import { EditChildBaseDialog } from '../EditChildBaseDialog';

export const SystemAnnouncementCreationDialog = ({
    onClose,
    readOnly,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    readOnly: boolean;
    autoGeneratedProps?: SystemAnnouncementResource;
    onCreated?: (id: string) => void;
}) => {
    const systemAnnouncementActions = useSystemAnnouncementActions();
    const addSystemAnnouncement = systemAnnouncementActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: SystemAnnouncementMutationResourceSchema,
        defaultValues: {
            ...defaultSystemAnnouncementResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            const creationResult = await addSystemAnnouncement.mutateAsync(data);
            if (creationResult?.successful) {
                if (onCreated && creationResult.content) {
                    onCreated(creationResult.content.id);
                }
                onClose();
            }
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create System Announcement'}
            dialogSize={DialogSize.MEDIUM}
            resourceType={ResourceType.SYSTEM_ANNOUNCEMENT}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                <SystemAnnouncementContent form={form} formNames={formNames} readOnly={readOnly} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
